import type { BlogRssPost } from '../types';

interface Rss2JsonItem {
  title?: string;
  link?: string;
  pubDate?: string;
  description?: string;
  content?: string;
  thumbnail?: string;
  enclosure?: {
    link?: string;
  } | null;
}

interface Rss2JsonResponse {
  items?: Rss2JsonItem[];
}

function stripHtml(html: string): string {
  if (typeof window === 'undefined') {
    return html
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
}

function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.slice(0, maxLength).trim()}…`;
}

function extractImageUrl(item: Rss2JsonItem): string {
  if (item.thumbnail) {
    return item.thumbnail;
  }

  if (item.enclosure && item.enclosure.link) {
    return item.enclosure.link;
  }

  const description = item.description || '';
  const imgMatch = description.match(/<img[^>]+src="([^">]+)"/);
  return imgMatch && imgMatch[1] ? imgMatch[1] : '';
}

export function parseRssFeed(data: Rss2JsonResponse, maxPosts: number): BlogRssPost[] {
  const items = (data.items || []).slice(0, maxPosts);

  return items.map((item) => {
    const title = item.title || '';
    const link = item.link || '';
    const pubDateText = item.pubDate || '';
    const description = item.description || '';
    const content = item.content || '';
    const imageUrl = extractImageUrl(item);

    const rawExcerpt = description.replace(/<figure[^>]*>.*<\/figure>/g, '') || content || '';
    const plainText = stripHtml(rawExcerpt);

    return {
      title: title.trim(),
      link: link.trim(),
      pubDate: pubDateText.trim(),
      excerpt: truncate(plainText, 160),
      imageUrl,
    };
  });
}

export function formatPostDate(pubDate: string): string {
  if (!pubDate) {
    return '';
  }

  try {
    const date = new Date(pubDate);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return '';
  }
}
